import { META_DATA } from "src/metadata/constants"
import { textToId } from "src/utilities/url"

export function createLdJsonSchemaId(input: string) {
  return META_DATA.origin + "/#schema-" + textToId(input)
}
